export default __webpack_public_path__ + "static/media/10.33f7458b.png";